import { render } from "./emailIcon.vue?vue&type=template&id=72a888b4&lang=true"
import script from "./emailIcon.vue?vue&type=script&lang=js"
export * from "./emailIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__